var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.customClass],on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('span',[_vm._v(_vm._s(_vm.description))]),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }